/* Loveleen Sari Palace — lookbook category filter + accessible lightbox */
(function () {
  /* ---------------------------------------------------------------
     FILTER
  --------------------------------------------------------------- */
  function initLookbook(root) {
    if (!root || root.getAttribute('data-lsp-init') === 'true') return;
    root.setAttribute('data-lsp-init', 'true');
    var modes = root.querySelectorAll('[data-lb-mode]');
    var panels = root.querySelectorAll('[data-lb-panel]');
    var choices = root.querySelectorAll('[data-lb-choice]');
    var cards = root.querySelectorAll('.card');
    var live = root.querySelector('[data-lb-live]');
    var help = root.querySelector('[data-lb-help]');
    var empty = root.querySelector('[data-lb-empty]');
    var track = root.querySelector('.grid');
    var prev = root.querySelector('[data-lb-prev]');
    var next = root.querySelector('[data-lb-next]');
    if (!modes.length || !choices.length || !cards.length) return;
    var mode = 'outfit', selected = 'all';
    var explanations = {
      saris: 'A long fabric draped around the body, worn with a blouse.',
      lehengas: 'A skirt, blouse and dupatta — a coordinating scarf.',
      'suits-shararas': 'Coordinated tops and trousers; shararas have wide, flared legs.',
      'gowns-anarkalis': 'One-piece dresses, including flowing, flared anarkalis.',
      mens: 'Explore kurtas, jackets and coordinated men’s looks.',
      kids: 'Indian occasion outfits for the little ones.',
      accessories: 'Finishing touches to bring your outfit together.',
      guest: 'Outfit inspiration for celebrating with the couple.',
      diwali: 'Festive looks for celebrating the Festival of Lights.',
      pastels: 'Soft shades for invitations that call for pastels.',
      haldi: 'Yellow is a popular choice — follow the couple’s dress code.',
      mehndi: 'Colorful looks for the henna celebration.',
      sangeet: 'Celebration looks for an evening of music and dancing.',
      reception: 'Dressy looks for the wedding reception.',
      bridal: 'Browse photographed bridal styles in the lookbook.',
      groom: 'Explore groom looks and coordinated ensembles.'
    };
    function tags(card, attribute) {
      return (card.getAttribute(attribute) || '').split(',').map(function (s) { return s.trim().toLowerCase(); });
    }
    function sync() {
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = max <= 0 || track.scrollLeft >= max;
    }
    function apply() {
      Array.prototype.forEach.call(modes, function (button) { button.setAttribute('aria-pressed', String(button.getAttribute('data-lb-mode') === mode)); });
      Array.prototype.forEach.call(panels, function (panel) { panel.hidden = panel.getAttribute('data-lb-panel') !== mode; });
      var label = '';
      Array.prototype.forEach.call(choices, function (button) {
        var active = button.closest('[data-lb-panel]').getAttribute('data-lb-panel') === mode && button.getAttribute('data-lb-choice') === selected;
        button.setAttribute('aria-pressed', String(active));
        if (active) label = button.textContent;
      });
      var shown = 0;
      Array.prototype.forEach.call(cards, function (card) {
        var show = selected === 'all' || tags(card, mode === 'outfit' ? 'data-outfit' : 'data-cat').indexOf(selected) !== -1;
        card.style.display = show ? '' : 'none';
        if (show) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
      if (help) help.textContent = explanations[selected] || (mode === 'outfit' ? 'Choose a style to explore.' : 'Choose your event or dress code.');
      if (live) live.textContent = shown ? 'Showing ' + shown + ' ' + (shown === 1 ? 'look' : 'looks') + (selected !== 'all' ? ' for ' + label : '') + '.' : 'No photographed looks in this group yet.';
      if (track) track.scrollLeft = 0;
      sync();
    }
    Array.prototype.forEach.call(modes, function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-lb-mode');
        if (mode !== target) { mode = target; selected = 'all'; apply(); }
      });
    });
    Array.prototype.forEach.call(choices, function (button) {
      button.addEventListener('click', function () { mode = button.closest('[data-lb-panel]').getAttribute('data-lb-panel'); selected = button.getAttribute('data-lb-choice'); apply(); });
    });
    var reset = root.querySelector('[data-lb-reset]');
    if (reset) reset.addEventListener('click', function () { selected = 'all'; apply(); });
    function choose(target) {
      target = String(target || '').toLowerCase();
      var aliases = { gowns: 'gowns-anarkalis', shararas: 'suits-shararas' };
      target = aliases[target] || target;
      var found = Array.prototype.find.call(choices, function (button) { return button.getAttribute('data-lb-choice') === target; });
      if (!found) return;
      mode = found.closest('[data-lb-panel]').getAttribute('data-lb-panel'); selected = target; apply();
    }
    root.addEventListener('lsp:filter', function (event) { choose(event.detail && event.detail.category); });
    var initial = new URLSearchParams(window.location.search).get('lookbook');
    if (initial) choose(initial);
    if (track && prev && next) {
      function page() {
        var card = Array.prototype.find.call(cards, function (item) { return item.style.display !== 'none'; });
        var w = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
        return Math.max(w, Math.floor(track.clientWidth / w) * w);
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
    }
    apply();
  }

  function initOccCarousel(root) {
    if (!root || root.getAttribute('data-occ-init') === 'true') return;
    root.setAttribute('data-occ-init', 'true');
    var track = root.querySelector('.grid');
    var prev = root.querySelector('[data-car-prev]');
    var next = root.querySelector('[data-car-next]');
    if (!track || !prev || !next) return;
    function page() {
      var card = track.querySelector('.card');
      var w = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      return Math.max(w, Math.floor(track.clientWidth / w) * w);
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------------------------------------------------------------
     LIGHTBOX — tap a photo to view it large
  --------------------------------------------------------------- */
  var lb = null, lbImg = null, lbCap = null, lbLive = null;
  var gallery = [], current = -1, lastFocused = null;

  function buildLightbox() {
    if (lb) return lb;

    lb = document.createElement('div');
    lb.className = 'lsp-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Photo viewer');
    lb.hidden = true;

    lb.innerHTML =
      '<button type="button" class="lb-close" aria-label="Close photo viewer">&times;</button>' +
      '<button type="button" class="lb-prev" aria-label="Previous photo">&#8249;</button>' +
      '<figure class="lb-figure">' +
        '<img class="lb-img" src="" alt="">' +
        '<figcaption class="lb-cap"></figcaption>' +
      '</figure>' +
      '<button type="button" class="lb-next" aria-label="Next photo">&#8250;</button>' +
      '<div class="lb-live sr-only" aria-live="polite"></div>';

    document.body.appendChild(lb);

    lbImg = lb.querySelector('.lb-img');
    lbCap = lb.querySelector('.lb-cap');
    lbLive = lb.querySelector('.lb-live');

    lb.querySelector('.lb-close').addEventListener('click', closeLightbox);
    lb.querySelector('.lb-prev').addEventListener('click', function () { step(-1); });
    lb.querySelector('.lb-next').addEventListener('click', function () { step(1); });

    /* Click the dark backdrop to close (but not the image itself) */
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('lb-figure')) closeLightbox();
    });

    /* Keyboard: Esc closes, arrows navigate, Tab is trapped inside */
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeLightbox(); return; }
      if (e.key === 'ArrowLeft') { step(-1); return; }
      if (e.key === 'ArrowRight') { step(1); return; }
      if (e.key === 'Tab') {
        var f = lb.querySelectorAll('button');
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* Swipe on touch devices */
    var startX = null;
    lb.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) step(dx > 0 ? -1 : 1);
      startX = null;
    }, { passive: true });

    return lb;
  }

  function show(i) {
    if (!gallery.length) return;
    current = (i + gallery.length) % gallery.length;
    var item = gallery[current];
    lbImg.src = item.src;
    lbImg.alt = item.title ? item.title : 'Enlarged photo';
    lbCap.textContent = item.title + (item.cat ? ' · ' + item.cat : '');
    lbLive.textContent = 'Photo ' + (current + 1) + ' of ' + gallery.length + ': ' + item.title;

    var multi = gallery.length > 1;
    lb.querySelector('.lb-prev').style.display = multi ? '' : 'none';
    lb.querySelector('.lb-next').style.display = multi ? '' : 'none';
  }

  function step(dir) { show(current + dir); }

  function openLightbox(cards, index) {
    buildLightbox();
    lastFocused = document.activeElement;

    gallery = Array.prototype.filter.call(cards, function (c) {
      return c.style.display !== 'none';
    }).map(function (c) {
      var img = c.querySelector('img');
      var h3 = c.querySelector('h3');
      var cat = c.querySelector('.cat');
      return {
        src: img ? (img.currentSrc || img.src) : '',
        title: h3 ? h3.textContent.trim() : '',
        cat: cat ? cat.textContent.trim() : ''
      };
    }).filter(function (item) { return item.src; });

    if (!gallery.length) return;

    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    show(index);
    lb.querySelector('.lb-close').focus();
  }

  function closeLightbox() {
    if (!lb) return;
    lb.hidden = true;
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function initLightboxOn(root) {
    if (!root || root.getAttribute('data-lsp-lb') === 'true') return;
    root.setAttribute('data-lsp-lb', 'true');

    var cards = root.querySelectorAll('.card');

    Array.prototype.forEach.call(cards, function (card, i) {
      var photo = card.querySelector('.photo');
      if (!photo || !photo.querySelector('img')) return;

      photo.classList.add('is-zoomable');
      photo.setAttribute('role', 'button');
      photo.setAttribute('tabindex', '0');
      var title = card.querySelector('h3');
      photo.setAttribute('aria-label', 'View larger photo' + (title ? ' of ' + title.textContent.trim() : ''));

      function openThis() {
        /* index among currently-visible cards */
        var visible = Array.prototype.filter.call(cards, function (c) { return c.style.display !== 'none'; });
        openLightbox(cards, visible.indexOf(card));
      }

      photo.addEventListener('click', openThis);
      photo.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openThis(); }
      });
    });
  }

  /* ---------------------------------------------------------------
     BOOT
  --------------------------------------------------------------- */
  /* Blog article images — make every content image zoomable */
  function initArticleImages() {
    var scopes = document.querySelectorAll(
      '.article-template__content, .article-content, .rte, article .rte, [data-lsp-article]'
    );
    if (!scopes.length) return;

    var imgs = [];
    Array.prototype.forEach.call(scopes, function (scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('img'), function (im) {
        if (im.closest('a')) return;                    // don't hijack linked images
        if (im.closest('button')) return;               // nor images that are already a control
        if (im.getAttribute('data-lsp-zoomed') === '1') return;
        if (im.naturalWidth && im.naturalWidth < 400) return;  // skip tiny icons
        im.setAttribute('data-lsp-zoomed', '1');
        imgs.push(im);
      });
    });

    if (!imgs.length) return;

    imgs.forEach(function (im, idx) {
      im.style.cursor = 'zoom-in';
      im.setAttribute('tabindex', '0');
      im.setAttribute('role', 'button');
      var label = im.getAttribute('alt');
      im.setAttribute('aria-label', 'View larger image' + (label ? ': ' + label.slice(0, 80) : ''));

      function open() {
        buildLightbox();
        lastFocused = document.activeElement;
        gallery = imgs.map(function (g) {
          return {
            src: g.currentSrc || g.src,
            title: (g.getAttribute('alt') || '').split('—')[0].split(':')[0].trim() || 'Photo',
            cat: ''
          };
        });
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
        show(idx);
        lb.querySelector('.lb-close').focus();
      }

      im.addEventListener('click', open);
      im.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });
  }

  function initAll() {
    /* These theme icons are decorative; their surrounding controls provide the names. */
    Array.prototype.forEach.call(document.querySelectorAll('svg.icon, svg.spinner'), function (icon) {
      if (icon.hasAttribute('aria-label') || icon.hasAttribute('aria-labelledby') || icon.querySelector('title')) return;
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-lsp-lookbook]'), function (root) {
      initLookbook(root);
      initLightboxOn(root);
    });
    /* Occasions carousel — independent of the lookbook section */
    Array.prototype.forEach.call(document.querySelectorAll('.lsp-occ, .lsp-guides'), initOccCarousel);
    /* Also enable the lightbox on the occasions grid */
    Array.prototype.forEach.call(document.querySelectorAll('[data-lsp-zoom]'), initLightboxOn);
    /* And on blog article images */
    initArticleImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelector) return;
    var root = e.target.querySelector('[data-lsp-lookbook]');
    if (root) {
      root.setAttribute('data-lsp-init', 'false');
      root.setAttribute('data-lsp-lb', 'false');
      initLookbook(root);
      initLightboxOn(root);
    }
    var occ = e.target.querySelector('.lsp-occ, .lsp-guides');
    if (occ) { occ.setAttribute('data-occ-init', 'false'); initOccCarousel(occ); }
    var zoom = e.target.querySelector('[data-lsp-zoom]');
    if (zoom) { zoom.setAttribute('data-lsp-lb', 'false'); initLightboxOn(zoom); }
  });
})();


/* Occasion cards open the matching lookbook selection. */
document.addEventListener('click', function (event) {
  var card = event.target.closest('.lsp-occ .card');
  if (!card) return;
  if (card.getAttribute('href') && card.getAttribute('href').indexOf('#lookbook') === -1) return;
  var category = card.querySelector('.meta span');
  var lookbook = document.querySelector('[data-lsp-lookbook]');
  if (!category || !lookbook) return;
  var target = category.textContent.trim().toLowerCase();
  var options = lookbook.querySelectorAll('option');
  if (!Array.prototype.some.call(options, function (option) { return option.value === target; }) && target !== 'mens') return;
  event.preventDefault();
  lookbook.dispatchEvent(new CustomEvent('lsp:filter', { detail: { category: target } }));
  document.getElementById('lookbook').scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* Rent-versus-buy photo carousel: swipe, buttons, and keyboard. */
(function () {
  function initRentCarousel() {
    var track = document.getElementById('rent-photo-track');
    if (!track || track.getAttribute('data-rent-carousel-ready') === 'true') return;
    var wrap = track.closest('.rent-carousel');
    if (!wrap) return;
    var prev = wrap.querySelector('.rent-prev');
    var next = wrap.querySelector('.rent-next');
    if (!prev || !next) return;
    track.setAttribute('data-rent-carousel-ready', 'true');
    track.setAttribute('aria-label', 'Browse nine outfit photos');
    prev.setAttribute('aria-label', 'Previous outfit photos');
    next.setAttribute('aria-label', 'Next outfit photos');
    prev.setAttribute('aria-controls', track.id);
    next.setAttribute('aria-controls', track.id);
    function state() {
      prev.disabled = track.scrollLeft < 3;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
    }
    function move(direction) {
      var card = track.querySelector('.rent-slide');
      if (!card) return;
      var step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      track.scrollBy({left: direction * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', state, {passive: true});
    track.addEventListener('keydown', function (event) {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    window.addEventListener('resize', state);
    state();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRentCarousel);
  else initRentCarousel();
})();

/* Shopping carousels inside the wedding guides. */
(function () {
 function initGuideShopping() {
  Array.prototype.forEach.call(document.querySelectorAll('.lsp-guide-shopping'), function (root) {
   var track = root.querySelector('.guide-photo-track');
   var prev = root.querySelector('.guide-shop-prev');
   var next = root.querySelector('.guide-shop-next');
   if (!track || !prev || !next || root.getAttribute('data-shopping-ready') === 'true') return;
   root.setAttribute('data-shopping-ready', 'true');
   var title = root.querySelector('h2');
   track.setAttribute('aria-label', title ? title.textContent.trim() + ': outfit photos' : 'Outfit photos');
   prev.setAttribute('aria-label', 'Previous outfit photos');
   next.setAttribute('aria-label', 'Next outfit photos');
   prev.setAttribute('aria-controls', track.id);
   next.setAttribute('aria-controls', track.id);
   function state() {prev.disabled=track.scrollLeft<3;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;}
   function move(dir) {var card=track.querySelector('figure');if(!card)return;var step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0);track.scrollBy({left:dir*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
   prev.addEventListener('click',function(){move(-1);});
   next.addEventListener('click',function(){move(1);});
   track.addEventListener('scroll',state,{passive:true});
   track.addEventListener('keydown',function(e){if(e.target!==track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
   window.addEventListener('resize',state);state();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initGuideShopping);else initGuideShopping();
})();
